import {
  GTMPageFeatureId,
  InteractionContainerName,
  InteractionEvent,
  InteractionGoal,
} from '@/helpers/GTM/GTMParameters';
import { trackEvent } from '@/helpers/GTM/GTMTrack';

export function trackAgencyProfileLinkClicked(
  containerName: InteractionContainerName.LINK | InteractionContainerName.LOGO,
  targetUrl: string,
): void {
  trackEvent(InteractionEvent.PDP_INTERACTION, {
    interaction_containerName: containerName,
    page_targetUrl: targetUrl,
    interaction_goal: InteractionGoal.GO_TO_AGENCY_PROFILE,
    h_web_feature_id_019: GTMPageFeatureId.PDP_INTERACTION,
  });
}
